import { Button as AntdButton, Button } from "antd";
import { throttle } from "lodash";
import { useCallback } from "react";
import { useMemo } from "react";
import { useEffect, useRef, useState } from "react";

const usePdf = () => {
  const pdfWrapper = useRef(null);
  const [numberOfPages, setNumberOfPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [initialWidth, setInitialWidth] = useState(null);
  const pdfRefCallback = useCallback(
    (node) => {
      setInitialWidth({
        width: node.offsetWidth,
        height: node.offsetHeight,
      });
      return node;
    },
    [numberOfPages]
  );

  const setPdfSize = () => {
    setInitialWidth({
      width: pdfWrapper.current?.offsetWidth,
      height: pdfWrapper.current?.offsetHeight,
    });
  };

  // ---------- Starts :: pagination related ----------
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumberOfPages(numPages);
    setPageNumber(1);
  };
  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = useCallback(() => {
    changePage(-1);
  }, []);

  const nextPage = useCallback(() => {
    changePage(1);
  }, []);

  const getPaginationProps = useMemo(() => {
    return {
      previousPage,
      nextPage,
      changePage,
      numberOfPages,
      pageNumber,
    };
  }, [nextPage, numberOfPages, pageNumber, previousPage]);
  // ---------- Ends :: pagination related ----------

  useEffect(() => {
    setPdfSize();
    window.addEventListener("resize", throttle(setPdfSize, 3000));
    return () => {
      window.removeEventListener("resize", throttle(setPdfSize, 3000));
    };
  }, []);

  const pdfPagination = useMemo(() => {
    return (
      <div className="pdfPagination mt-4 flex justify-between items-center">
        <p className="">
          Page {pageNumber || (numberOfPages ? 1 : "--")} of{" "}
          {numberOfPages || "--"}
        </p>
        <div class="paginationButtons">
          <Button
            isSecondary
            disabled={pageNumber <= 1}
            onClick={previousPage}
            className="mr-3"
            htmlType="button"
          >
            Previous
          </Button>
          <Button
            isSecondary
            disabled={pageNumber >= numberOfPages}
            onClick={nextPage}
            htmlType="button"
          >
            Next
          </Button>
        </div>
      </div>
    );
  }, [nextPage, numberOfPages, pageNumber, previousPage]);

  return {
    pdfWrapper,
    initialWidth,
    onDocumentLoadSuccess,
    getPaginationProps,
    pdfPagination,
    pdfRefCallback,
  };
};

export default usePdf;
